import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=fa74714c&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa74714c",
  null
  
)

export default component.exports